import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Permission {
  name: string;
  type: string;
  resources: string[];
  scopes: string[];
  policies: string[];
  decisionStrategy: string;
}

export interface PermissionsState {
  permissions: Permission[];
}

const initialState: PermissionsState = {
  permissions: [],
};

const permissionsSlice = createSlice({
  name: "permissions",
  initialState,
  reducers: {
    setPermissions(state, action: PayloadAction<Permission[]>) {
      state.permissions = action.payload;
    },
    clearPermissions(state) {
      state.permissions = [];
    },
  },
});

export const { setPermissions, clearPermissions } = permissionsSlice.actions;
export default permissionsSlice.reducer;
